import React from 'react';
import { useLanguage } from './LanguageContext';
import MainSlider from './MainSlider';
import './DesktopVideo.css';

const DesktopVideo = () => {
    const { t } = useLanguage();

    return (
        <section className="desktop-video-section">
            <div className="desktop-video-container">
                <div className="desktop-video-header">
                    <h2 className="desktop-video-title">{t('ourProduction')}</h2>
                    <p className="desktop-video-subtitle">
                        {t('ourProductionDesc')}
                    </p>
                </div>

                <div className="desktop-video-wrapper">
                    <div className="desktop-video-player-container">
                        <MainSlider />
                    </div>
                </div>

                <div className="desktop-video-features">
                    <div className="desktop-video-feature">
                        <div className="feature-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="white" stroke="white" strokeWidth="1" />
                            </svg>
                        </div>
                        <span>{t('qualityMaterials')}</span>
                    </div>
                    <div className="desktop-video-feature">
                        <div className="feature-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" fill="white" stroke="white" strokeWidth="0.5" />
                                <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" fill="white" stroke="white" strokeWidth="0.5" />
                            </svg>
                        </div>
                        <span>{t('modernEquipment')}</span>
                    </div>
                    <div className="desktop-video-feature">
                        <div className="feature-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="white" stroke="white" strokeWidth="1" />
                            </svg>
                        </div>
                        <span>{t('fastProduction')}</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DesktopVideo;
